import { render } from "./NewsListPage.vue?vue&type=template&id=1fee16fd&scoped=true&ts=true"
import script from "./NewsListPage.vue?vue&type=script&lang=ts"
export * from "./NewsListPage.vue?vue&type=script&lang=ts"

import "./NewsListPage.vue?vue&type=style&index=0&id=1fee16fd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fee16fd"]])

export default __exports__